/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FullProductDto } from '../../models/full-product-dto';

export interface ProductGetProductById$Plain$Params {
  productId: string;
}

export function productGetProductById$Plain(http: HttpClient, rootUrl: string, params: ProductGetProductById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<FullProductDto>> {
  const rb = new RequestBuilder(rootUrl, productGetProductById$Plain.PATH, 'get');
  if (params) {
    rb.path('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FullProductDto>;
    })
  );
}

productGetProductById$Plain.PATH = '/api/Product/full/{productId}';
